import React from 'react';
import CookieConsentBanner from 'react-cookie-consent';
import Cookies from 'js-cookie';
import { logFacebookPageView } from '../utils/facebookSdk.js';

export default function CookieConsent() {
  const handleAcceptAll = () => {
    // Set all cookies
    Cookies.set('essential', 'true', { expires: 365 });
    Cookies.set('analytics', 'true', { expires: 365 });
    
    // Initialize GA if analytics accepted
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
    logFacebookPageView();
  };

  const handleAcceptRequired = () => {
    // Set only essential cookies
    Cookies.set('essential', 'true', { expires: 365 });
    Cookies.set('analytics', 'false', { expires: 365 });
    
    // Deny GA consent
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  };

  return (
    <CookieConsentBanner
      location="bottom"
      buttonText="Accept All"
      declineButtonText="Only Required"
      enableDeclineButton
      cookieName="driftcal-cookie-consent"
      style={{ 
        background: "#2B3035",
        alignItems: "center",
        padding: "1rem"
      }}
      buttonStyle={{ 
        background: "#10B981",
        color: "white",
        fontSize: "13px",
        borderRadius: "6px",
        padding: "8px 16px"
      }}
      declineButtonStyle={{
        background: "transparent",
        border: "1px solid #6B7280",
        color: "white",
        fontSize: "13px",
        borderRadius: "6px",
        padding: "8px 16px"
      }}
      expires={365}
      onAccept={handleAcceptAll}
      onDecline={handleAcceptRequired}
    >
      <div className="text-sm">
        <p className="mb-2">
          We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
        </p>
        <p className="text-xs text-gray-300">
          Essential cookies are necessary for the website to function. Analytics cookies help us improve our website.
          See our{' '}
          <a href="/privacy" className="underline text-white">
            privacy policy
          </a>
          .
        </p>
      </div>
    </CookieConsentBanner>
  );
} 